<template>
	<Transition name="fade" appear>
		<div v-if="state.visible" class="loading-overlay" :style="overlayStyle">
			<div class="root-box" :style="{ flexDirection: state.props.vertical ? 'column' : 'row' }">
				<div
					class="loader"
					:style="{
						'--_g': `no-repeat radial-gradient(circle closest-side, ${state.props.color} 90%, ${state.props.color}00)`,
						top: state.props.vertical ? '0' : '.2667rem',
						left: state.props.vertical ? 'unset' : '.2667rem',
					}"
				></div>
				<div class="text-12" :style="{ color: state.props.textColor || state.props.color }">
					{{ state.props.tip }}
				</div>
			</div>
		</div>
	</Transition>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue';

const props = defineProps<{
	state: {
		visible: boolean;
		props: {
			tip?: string;
			color?: string;
			textColor?: string;
			vertical?: boolean;
			background?: string;
			zIndex?: number;
			position?: string;
		};
	};
}>();

const overlayStyle = computed(() => ({
	position: (props.state.props.position || 'fixed') as 'fixed' | 'absolute' | 'relative' | 'static' | 'sticky',
	backgroundColor: props.state.props.background || 'rgba(0, 0, 0, 0.4)',
	zIndex: props.state.props.zIndex || 1999,
	width: '100%',
	height: '100%',
}));
const { state } = toRefs(props);
</script>

<style scoped lang="scss">
.loading-overlay {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}
.root-box {
	display: flex;
	justify-content: center;
	align-items: center;
}

.loader {
	width: 1.25rem;
	aspect-ratio: 2;
	// --_g: no-repeat radial-gradient(circle closest-side,#000 90%,#0000);
	background: var(--_g) 0% 50%, var(--_g) 50% 50%, var(--_g) 100% 50%;
	background-size: calc(100% / 3) 50%;
	animation: l3 0.75s infinite linear;
	opacity: 0.9;
}
@keyframes l3 {
	20% {
		background-position: 0% 0%, 50% 50%, 100% 50%;
	}
	40% {
		background-position: 0% 100%, 50% 0%, 100% 50%;
	}
	60% {
		background-position: 0% 50%, 50% 100%, 100% 0%;
	}
	80% {
		background-position: 0% 50%, 50% 50%, 100% 100%;
	}
}
</style>
